import {Box} from 'platform/foundation';

import {isNilOrEmpty} from 'ramda-adjunct';

import {RelatedCustomNoticesResourceId, useGetRelatedCustomNoticesQuery} from '@dms/api/core';

import {suffixTestId, TestIdProps} from 'shared/web';

interface CustomNoticesIndicatorProps extends TestIdProps {
  resourceId: RelatedCustomNoticesResourceId;
  recordId: string;
}

export function CustomNoticesIndicator(props: CustomNoticesIndicatorProps) {
  const {data: notices} = useGetRelatedCustomNoticesQuery({
    resourceId: props.resourceId,
    recordId: props.recordId,
  });

  if (isNilOrEmpty(notices)) {
    return null;
  }

  return (
    <Box
      position="absolute"
      top={1}
      right={1}
      width={2}
      height={2}
      borderRadius="circular"
      backgroundColor="palettes.red.50.100"
      data-testid={suffixTestId('customNoticesIndicator', props)}
    />
  );
}
